import { CountryCode } from 'libphonenumber-js';

export const HIGHLIGHTED_COUNTRY_CODES: CountryCode[] = ['BE', 'NL', 'LU'];

export const FALLBACK_COUNTRY_MAP: Record<string, CountryCode> = {
  'nl-NL': 'NL',
  fr: 'BE',
  nl: 'BE',
};
